import { StyleSheet, View } from 'react-native';
import { Image } from 'expo-image';
import { neutrals } from 'src/theme/colors';
import { lazy, Suspense } from 'react';

const LottieViewLazy = lazy(() => import('lottie-react-native'));
import animation from './assets/logoAnimated.json';

export const ImageLoadingPlaceholder = ({
  productId,
  userImageAreaId,
}: {
  productId?: string;
  userImageAreaId?: string;
}) => {
  const testId = productId && userImageAreaId ? `image-loading-placeholder.area-${productId}-${userImageAreaId}` : '';

  return (
    <View style={style.container} testID={testId}>
      <View style={[style.logo, style.staticLogo]}>
        <Image source={{ uri: '/logo.png' }} style={style.staticLogoImage} contentFit="contain" />
      </View>
      <View style={[style.logo, style.animatedLogo]}>
        <Suspense>
          <LottieViewLazy source={animation} autoPlay loop />
        </Suspense>
      </View>
    </View>
  );
};

const style = StyleSheet.create({
  container: {
    backgroundColor: neutrals.coldGrays.pearl,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  logo: {
    height: 120,
    maxWidth: 240,
  },
  staticLogo: {
    width: '100%',
  },
  staticLogoImage: {
    width: '100%',
    height: '100%',
  },
  animatedLogo: {
    position: 'absolute',
    zIndex: 1,
  },
});
